import {
  FIELD_TEMPLATE_FETCH_REQUEST,
  FIELD_TEMPLATE_FETCH_REQUEST_SUCCESS,
  FIELD_TEMPLATE_FETCH_REQUEST_FAILURE,
  FIELD_TEMPLATE_UPSERT_REQUEST,
  FIELD_TEMPLATE_UPSERT_REQUEST_SUCCESS,
  FIELD_TEMPLATE_UPSERT_REQUEST_FAILURE,
  FIELD_TEMPLATE_DELETE_REQUEST,
  FIELD_TEMPLATE_DELETE_REQUEST_SUCCESS,
  FIELD_TEMPLATE_DELETE_REQUEST_FAILURE,
  FIELD_TEMPLATE_CLEAN_REQUEST,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  upsertPayload: [],
  upsertLoading: false,
  upsertErrors: {},
  deletePayload: [],
  deleteLoading: false,
  deleteErrors: {},
};

const fieldTemplateReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    // Fetch
    case FIELD_TEMPLATE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case FIELD_TEMPLATE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data ?? [],
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
          showSizeChanger: true,
        },
      });

    case FIELD_TEMPLATE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        payload: [],
        errors: action.error,
      });

    // Upsert
    case FIELD_TEMPLATE_UPSERT_REQUEST:
      return Object.assign({}, state, {
        upsertLoading: true,
      });

    case FIELD_TEMPLATE_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        upsertLoading: false,
        upsertPayload: action.data,
      });

    case FIELD_TEMPLATE_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        upsertLoading: false,
        upsertPayload: [],
        upsertErrors: action.error,
      });

    // Delete
    case FIELD_TEMPLATE_DELETE_REQUEST:
      return Object.assign({}, state, {
        deleteLoading: true,
        deleteErrors: {},
      });

    case FIELD_TEMPLATE_DELETE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        deleteLoading: false,
        deletePayload: action.data,
        deleteErrors: {},
      });

    case FIELD_TEMPLATE_DELETE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        deleteLoading: false,
        deletePayload: [],
        deleteErrors: action.error,
      });

    // Clean
    case FIELD_TEMPLATE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
        upsertPayload: [],
        upsertLoading: false,
        upsertErrors: {},
        deletePayload: [],
        deleteLoading: false,
        deleteErrors: {},
      });

    default:
      return state;
  }
};

export default fieldTemplateReducer;
